

























export default {
    name: 'TextInput',

    props: {
        label: {
            required: false,
            type: String,
        },
        value: {
            required: false,
            type: [String, Number],
        },
        placeholder: {
            required: false,
            type: String,
        },
        error: {
            default: '',
            required: false,
            type: String,
        },
        disabled: {
            required: false,
            type: Boolean,
        },
        optional: {
            required: false,
            type: Boolean,
            default: false,
        },
        readonly: {
            default: false,
            required: false,
            type: Boolean,
        },
        hideErrorText: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    methods: {
        updateValue(value: string) {
            this.$emit('input', value);
        },
    },
};
